import React from 'react'
import { Route } from 'react-router-dom'
import { IonApp, IonRouterOutlet } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
// import { useSelector } from 'react-redux'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

/* Theme variables */
import './theme/variables.css'
// import { ReduxStore } from './redux/reducers'
// import { UserModel } from './model/user.model'
import Home from './pages/Home'
import SignIn from './pages/SignIn'
import BindBot from './pages/BindBot'
import MyKnowledge from './pages/MyKnowledge'
import MyBot from './pages/MyBot'
import Learning from './pages/Learning'
import HelpCenter from './pages/HelpCenter'
import KnowledgeDetail from './pages/KnowledgeDetail'
import QuestionDetail from './pages/QuestionDetail'
import CombineKnowledge from './pages/CombineKnowledge'
import BotStore from './pages/BotStore'
import BotKnowledges from './pages/BotKnowledges'
import ProductIntro from './pages/ProductIntro'
import BindWechat from './pages/BindWechat'
import WechatBot from './pages/WechatBot'
import Contacts from './pages/Contacts'
import SetNewsBot from './pages/SetNewsBot'
import ResetPsw from './pages/Reset'
import ScheduleRemind from './pages/ScheduleRemind'
import ScheduleRemindDetail from './pages/ScheduleRemindDetail'

import {
    HomePage,
    MyKnowledgePage,
    KnowledgeDetailPage,
    MyBotPage,
    BotKnowledgesPage,
    BotStorePage,
    QuestionDetailPage,
    CombileKnowledgePage,
    HelpPage,
    SigninPage,
    SignupPage,
    LearningPage,
    BindBotPage,
    BotDetailPage,
    ProductIntroPage,
    BindWechatPage,
    WechatBotPage,
    ContactsPage,
    SetNewsBotPage,
    NewsBotDetailPage,
    GroupDataStatisticsPage,
    BotPushServicePage,
    BotPushServiceDetailPage,
    PasswordPage,
    NoticePage,
    ManageGroupPage,
    GroupWelcomePage,
    Reset,
    ScheduleRemindPage,
    ScheduleRemindDetailPage,
} from './conf/routePath'
import SignUp from './pages/SignUp'
import BotDetail from './pages/BotDetail'
import NewsBotDetail from './pages/NewsBotDetail'
import GroupDataStatistics from './pages/GroupDataStatistics'
import BotPushService from './pages/BotPushService'
import BotPushServiceDetail from './pages/BotPushServiceDetail'
import Password from './pages/Password'
import Notice from './pages/Notice'
import ManageGroup from './pages/ManageGroup'
import GroupWelcome from './pages/GroupWelcome'

const App: React.FC = (props) => {
    // const userInfo = useSelector<ReduxStore, UserModel | null>(
    //     (store) => store.userInfo
    // )
    // console.log(props)
    return (
        <IonApp>
            <IonReactRouter>
                <IonRouterOutlet animated={false}>
                    <Route path={HomePage} component={Home} exact={true} />
                    <Route
                        path={BindBotPage}
                        component={BindBot}
                        exact={true}
                    />
                    <Route
                        path={MyKnowledgePage}
                        component={MyKnowledge}
                        exact={true}
                    />
                    <Route
                        path={KnowledgeDetailPage}
                        component={KnowledgeDetail}
                        exact={true}
                    />
                    <Route path={MyBotPage} component={MyBot} exact={true} />
                    <Route
                        path={BotKnowledgesPage}
                        component={BotKnowledges}
                        exact={true}
                    />
                    <Route
                        path={BotStorePage}
                        component={BotStore}
                        exact={true}
                    />
                    <Route
                        path={BotDetailPage}
                        component={BotDetail}
                        exact={true}
                    />
                    <Route
                        path={LearningPage}
                        component={Learning}
                        exact={true}
                    />
                    <Route
                        path={QuestionDetailPage}
                        component={QuestionDetail}
                        exact={true}
                    />
                    <Route
                        path={CombileKnowledgePage}
                        component={CombineKnowledge}
                        exact={true}
                    />
                    <Route
                        path={BindWechatPage}
                        component={BindWechat}
                        exact={true}
                    />
                    <Route
                        path={WechatBotPage}
                        component={WechatBot}
                        exact={true}
                    />
                    <Route
                        path={HelpPage}
                        component={HelpCenter}
                        exact={true}
                    />
                    <Route
                        path={ManageGroupPage}
                        component={ManageGroup}
                        exact={true}
                    />
                    <Route
                        path={ProductIntroPage}
                        component={ProductIntro}
                        exact={true}
                    />
                    <Route
                        path={ContactsPage}
                        component={Contacts}
                        exact={true}
                    />
                    <Route path={SigninPage} component={SignIn} exact={true} />
                    <Route path={SignupPage} component={SignUp} exact={true} />
                    <Route path={Reset} component={ResetPsw} exact={true} />
                    <Route
                        path={NewsBotDetailPage}
                        component={NewsBotDetail}
                        exact
                    />
                    <Route path={SetNewsBotPage} component={SetNewsBot} exact />
                    <Route
                        path={ScheduleRemindPage}
                        component={ScheduleRemind}
                        exact
                    />
                    <Route
                        path={ScheduleRemindDetailPage}
                        component={ScheduleRemindDetail}
                        exact
                    />
                    <Route
                        path={GroupDataStatisticsPage}
                        component={GroupDataStatistics}
                        exact
                    />
                    <Route
                        path={BotPushServicePage}
                        component={BotPushService}
                        exact
                    />
                    <Route
                        path={BotPushServiceDetailPage}
                        component={BotPushServiceDetail}
                        exact
                    />
                    <Route path={PasswordPage} component={Password} exact />
                    <Route path={NoticePage} component={Notice} exact />
                    <Route
                        path={GroupWelcomePage}
                        component={GroupWelcome}
                        exact
                    />
                    {/* {userInfo ? (
                        <Redirect exact from='/' to={HomePage} />
                    ) : (
                        <Redirect from={HomePage} to={SigninPage} />
                    )} */}
                </IonRouterOutlet>
            </IonReactRouter>
        </IonApp>
    )
}

export default App
